import { useQuery } from '@parkchirp/api-client';

import {
	LIST_ADJUSTMENTS_INVOICE_HISTORY,
	LIST_CREDITS_INVOICE_HISTORY,
	LIST_PAYMENTS_INVOICE_HISTORY,
	LIST_REFUND_INVOICE_HISTORY,
	LIST_REVERSALS_INVOICE_HISTORY,
} from '../../../queries';

export function useFetchInvoiceHistoryData(invoiceId: string, appName: string) {
	const {
		data: adjustments,
		loading: adjustmentsLoading,
		refetch: refetchAdjustments,
	} = useQuery(LIST_ADJUSTMENTS_INVOICE_HISTORY, {
		notifyOnNetworkStatusChange: true,
		variables: {
			invoiceId,
		},
		context: {
			apiVersion: 'v2',
			appName,
		},
		fetchPolicy: 'network-only',
		skip: !invoiceId,
	});
	const {
		data: reversals,
		loading: reversalsLoading,
		refetch: refetchReversals,
	} = useQuery(LIST_REVERSALS_INVOICE_HISTORY, {
		notifyOnNetworkStatusChange: true,
		variables: {
			invoiceId,
		},
		context: {
			apiVersion: 'v2',
			appName,
		},
		fetchPolicy: 'network-only',
		skip: !invoiceId,
	});
	const {
		data: payments,
		loading: paymentsLoading,
		refetch: refetchPayments,
	} = useQuery(LIST_PAYMENTS_INVOICE_HISTORY, {
		notifyOnNetworkStatusChange: true,
		variables: {
			invoiceId,
		},
		context: {
			apiVersion: 'v2',
			appName,
		},
		fetchPolicy: 'network-only',
		skip: !invoiceId,
	});
	const {
		data: credits,
		loading: creditsLoading,
		refetch: refetchCredits,
	} = useQuery(LIST_CREDITS_INVOICE_HISTORY, {
		notifyOnNetworkStatusChange: true,
		variables: {
			invoiceId,
		},
		context: {
			apiVersion: 'v2',
			appName,
		},
		fetchPolicy: 'network-only',
		skip: !invoiceId,
	});
	const {
		data: refunds,
		loading: refundLoading,
		refetch: refetchRefunds,
	} = useQuery(LIST_REFUND_INVOICE_HISTORY, {
		notifyOnNetworkStatusChange: true,
		variables: {
			invoiceId,
		},
		context: {
			apiVersion: 'v2',
			appName,
		},
		fetchPolicy: 'network-only',
		skip: !invoiceId,
	});

	const isLoading = adjustmentsLoading || paymentsLoading || reversalsLoading || creditsLoading || refundLoading;

	if (isLoading) {
		return {
			historyData: [],
			loading: isLoading,
		};
	}

	const mergedData = [
		...(adjustments?.listAdjustmentsInvoiceHistory || []),
		...(payments?.listPaymentsInvoiceHistory || []),
		...(refunds?.listRefundsInvoiceHistory || []),
		...(credits?.listCreditsInvoiceHistory || []),
		...(reversals?.listReversalsInvoiceHistory || []),
	];

	const sortData = mergedData.sort((a, b) => new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf());

	const dataWithBalance = sortData.reduce(
		(acc, curr, i) => [
			...acc,
			{
				...curr,
				currentBalance: (acc[i - 1]?.currentBalance || 0) + (curr.amount || 0),
			},
		],
		[],
	);

	return {
		historyData: dataWithBalance,
		loading: isLoading,
		refetch: () => {
			refetchAdjustments();
			refetchReversals();
			refetchPayments();
			refetchCredits();
			refetchRefunds();
		},
	};
}
